import React, { useContext, useState, useCallback, useMemo, memo, useEffect } from 'react';
import "./TaskTags.css"
import axios from 'axios';
import { Context } from '../../../..';
import { AppContext } from '../../../../App';
import Button from '../../../UiLib/Button/Button';
import { ReactComponent as Cross } from "../../../../assets/images/cross.svg"
import TagsContainer from '../../../Shared/Tags/TagsContainer';
import TagSelector from '../../../Shared/TagSelector/TagSelector';
import WidgetContainer from '../../../UiLib/WidgetContainer/WidgetContainer';
import { ITag } from '../../../../common/api_interfaces/tag/ITag';

import { ReactComponent as Pluss } from "../../../../assets/images/addDefault.svg";

const tagsFolded: React.CSSProperties = {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    overflowX: "hidden"
}

const tagsUnfolded: React.CSSProperties = {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    flexWrap: "wrap"
}

const buttonUnfolded: React.CSSProperties = {
    backgroundColor: "lightgray",
    color: "#fff",
    padding: "3px"
}
interface ITasksTagDisplayProps {
    tags: ITag[];
    projectId: number;
    taskId: number | undefined;
    addTagsFunc: (tags: ITag[]) => void;
    removeTags: (tag: ITag | ITag[]) => void;
    permission?: boolean;
}

const TaskTags: React.FC<ITasksTagDisplayProps> = memo(({
    tags,
    projectId,
    taskId,
    addTagsFunc,
    removeTags,
    permission
}) => {
    const { store } = useContext(Context);
    const [showTagPopup, setShowTagPopup] = useState(false);
    const [thisTags, setThisTags] = useState<ITag[]>(tags);

    const { showToast } = useContext(AppContext);

    useEffect(() => {
        setThisTags(tags);
    }, [tags])

    const onClosePopup = useCallback(() => {
        setShowTagPopup(false);
    }, []);

    const onAddButton = useCallback(async () => {
        if (!permission) {
            showToast("У вас нет прав для редактирования задачи!");
            return;
        }

        try {
            await store.taskService.getTegs({
                taskId: taskId,
                projectId: projectId,
                userId: 0,
            });
            setShowTagPopup(true);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                showToast(error.response?.data?.message);
            }
        }
    }, [permission, store.taskService, showToast]);

    const onAddTagsAccept = useCallback(async (_tags: ITag[]) => {
        addTagsFunc(_tags);
    }, [addTagsFunc]);

    const handleRemoveTags = useCallback(async (_tags: ITag | ITag[]) => {
        if (!permission) {
            showToast("У вас нет прав для редактирования задачи!");
            return;
        }
        removeTags(_tags);
    }, [permission, removeTags, showToast]);

    return (
        <div className='task-tags-component'>        
            <TagsContainer
                tags={thisTags}
            />
                {showTagPopup && (
                    <div className='task__teg--display__popup--add__teg'>
                        <WidgetContainer>
                            <div className='task__teg--display__popup--add__teg--header'>
                                <div className='task__teg--display__popup--add__teg--name'>
                                    Добавление тегов
                                </div>
                                <Button
                                    id="button-cross"
                                    callBack={onClosePopup}
                                    image={<Cross />}
                                />
                            </div>
                            <div className='task__teg--display__popup--add__teg--name__TagSelector'>
                                <TagSelector
                                    tags={thisTags}
                                    projectId={projectId}
                                    taskId={taskId}
                                    addTagsFunc={onAddTagsAccept}
                                    removeTagsFunc={handleRemoveTags}
                                    closeFunc={onClosePopup}
                                />
                            </div>
                            <div className='tegs__color--popup__button--add__save--block'>
                                <div 
                                    className='tegs__color--popup__button--add__teg'
                                    onClick={onClosePopup}
                                >
                                    Сохранить
                                </div>
                            </div>
                        </WidgetContainer>
                    </div>
                )}
            <div>
                <Button
                    id={permission ? "button-circle-add" : "button-circle-add-gray"}
                    callBack={permission ? onAddButton : () => showToast("У вас нет прав на редактирование тегов")}
                    image={<Pluss/>}
                />
            </div>
        </div>
    );
});

TaskTags.displayName = 'TaskTags';

export default TaskTags;